import { useMutation } from "@tanstack/react-query";
import axios from "axios";

// Set your base URL here
const BASE_URL = process.env.REACT_APP_BACKEND_HOSTED_ON;

const fetchData = async ({
  endpoint,
  method = "GET",
  headers = {},
  body = null,
}) => {
  const config = {
    method,
    url: `${BASE_URL}${endpoint}`,
    headers,
    data: body,
  };

  try {
    const { data } = await axios(config);
    return data;
  } catch (error) {
    // Throw the error to be caught in the mutation
    throw error;
  }
};

// Custom hook for mutation
export const useTanstackApiCall = (
  endpoint,
  headers = {},
  method = "GET",
  params = {}
) => {
  return useMutation({
    mutationFn: (body) => fetchData({ endpoint, headers, method, body }),
    onError: (error) => {
      // Handle error logging or additional actions here if needed
      console.error("API call failed:", error);
    },
  });
};
